import dashboardVerticalIcon from '@disy/cadenza-icons/dashboard-ver-split.svg';

import { Action } from 'cadenza/action';
import { icon } from 'cadenza/utils/icon/icon';
import { VIEW } from 'cadenza/map-dashboard/event-types';
import type { TableView } from 'cadenza/map-dashboard/table-view/table-view';

import i18n from '../messages.properties';

export class ToggleVerticalLayoutAction extends Action {

  _tableView: TableView;

  constructor (tableView: TableView) {
    super({ label: i18n('verticalLayout'), icon: icon(dashboardVerticalIcon) });
    this._tableView = tableView;
  }

  override executeSync () {
    this._tableView.dispatchEvent(new CustomEvent(VIEW.LAYOUT_CHANGED, { bubbles: true, detail: { orientation: 'vertical' } }));
  }

  override isSupportedSync () {
    return true;
  }

}
